// src/Projects.js

import React from "react";
import { useNavigate } from "react-router-dom";
import "./Projects.css";
import { FaPlay } from "react-icons/fa";
import ImageLoader from "./ImageLoader";

import { useData } from "./DataProvider";

export default function Projects() {
  const { projectsData: projects } = useData();
  const navigate = useNavigate();

  const sorted = [...projects].sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return 0;
  });

  const handleProjectClick = (idx) => {
    navigate(`/projects/${idx}`);
  };

  return (
    <div className="projects-container">
      <div className="projects-header">
        <h2 className="projects-title">My Projects</h2>
      </div>

      <div className="projects-grid">
        {sorted.map((p, idx) => (
          <div key={idx} className="project-card" onClick={() => handleProjectClick(idx)}>
            <div className="project-image-container">
              <ImageLoader src={p.img} alt={p.title} className="project-image" />
              <div className="play-overlay">
                <FaPlay size={20} style={{ marginLeft: '4px' }} />
              </div>
            </div>
            <div className="project-name">{p.title}</div>
            <div className="project-desc">{p.blurb}</div>
            <div className="technologies">{p.tech?.slice(0, 3).join(", ")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
